import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, TextBox1, TextBox2, ImgBox1, Wrapper, Wrapper2, VideoWrapper } from "./style";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = () => {
  const { t } = useTranslation("home");
  const language = useSelector(selectLanguage);
  const ref = useRef();

  useScrollFadeIn(ref);

  const [ios, setIos] = useState(false);
  useEffect(() => {
    if (navigator.userAgent.match(/iPhone/i)) {
      setIos(true);
    }
  }, []);

  const navHandler = (to) => {
    window.open(to, "_blank");
  };
  return (
    <Container>
      <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/5e17c761Home_3.png" alt="" />
      <Wrapper ref={ref} className="fade-in">
        <TextBox1 language={language}>
          <span>{t("1-1")}</span>
          <span>{t("1-2")}</span>
        </TextBox1>
        <TextBox2>
          <span>{t("1-3")}</span>
          <span>{t("1-4")}</span>
        </TextBox2>
        <ImgBox1>
          <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/6b2dab61Home_10.svg" alt="QR" />
          <div>
            <div href="/" alt="googlePlayStore">
              {language === "en" ? (
                <a
                  href="https://play.google.com/store/apps/details?id=com.sketch.wallet"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4f46f708Home_12.svg"
                    alt="googlePlayStore"
                  />
                </a>
              ) : (
                <a
                  href="https://play.google.com/store/apps/details?id=com.sketch.wallet"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/884be2c9Home_1.svg"
                    alt="googlePlayStore"
                  />
                </a>
              )}
            </div>
            <div href="/" alt="appleStore">
              {language === "en" ? (
                <a
                  href="https://apps.apple.com/kr/app/%EC%8A%A4%EC%BC%80%EC%B9%98%EC%9B%94%EB%A0%9B-sketch-wallet-bitsafe/id1597866658"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/959c55f4Home_13.svg"
                    alt="AppleStore"
                  />
                </a>
              ) : (
                <a
                  href="https://apps.apple.com/kr/app/%EC%8A%A4%EC%BC%80%EC%B9%98%EC%9B%94%EB%A0%9B-sketch-wallet-bitsafe/id1597866658"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/d57a6aa0Home_2.svg"
                    alt="AppleStore"
                  />
                </a>
              )}
            </div>
          </div>
        </ImgBox1>
      </Wrapper>
      <Wrapper2>
        {ios ? (
          <div>
            <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c09cdf4eHome_1.png" alt="phoneImg" />
          </div>
        ) : (
          <div>
            <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4ce85fc6Home_4.svg" alt="phoneImg" />
            <VideoWrapper>
              <video autoPlay muted loop>
                <source src="/assets/video/wallet_video.mp4" type="video/mp4" />
              </video>
            </VideoWrapper>
          </div>
        )}
      </Wrapper2>
    </Container>
  );
};

export default Com1;
